import { Select } from '../Select';
import * as React from 'react';
import { EMaterials } from '../../../../types/buildersProjects';

const MATERIALS_OPTIONS = [
  { label: 'Блоки', value: EMaterials.Blocks },
  { label: 'Кирпич', value: EMaterials.Brick },
  { label: 'Клееный брус', value: EMaterials.GluedLaminatedTimber },
  { label: 'Цельное дерево', value: EMaterials.SolidTree },
  { label: 'Каркас', value: EMaterials.FrameHouses },
  { label: 'Монолит', value: EMaterials.Monolith },
  { label: 'SIP-технологии', value: EMaterials.Sip },
  { label: 'Другое', value: EMaterials.Other },
];

interface IMaterialsDropdown {
  materials: EMaterials[];
  onChange: (selected: EMaterials[]) => void;
  filterRef: React.RefObject<HTMLDivElement | null>;
  onClose(): void;
  tooltipOpened: boolean;
}

export const MaterialsDropdown: React.FC<IMaterialsDropdown> = ({
  materials,
  onChange,
  tooltipOpened,
  filterRef,
  onClose,
}) => {
  return (
    <Select
      selected={materials}
      options={MATERIALS_OPTIONS}
      onChange={onChange}
      tooltipOpened={tooltipOpened}
      hostElement={filterRef.current}
      onApply={onClose}
    />
  );
};
